import React, { Component } from 'react';
import { Form, Input, Button, Spin, notification } from 'antd';
import { sessionManager } from '../../core/SessionManager';
import { post } from '../../utils/http';
import api from '../../utils/api';
import { encrypt } from '../../services/AuthService';
import { Redirect } from 'react-router-dom';

class Settings extends Component {
        constructor(props) {
                super(props)
                this.state = {
                        currentPwd: "",
                        newPwd: "",
                        checkPwd: "",
                        loading: false,
                        isChecked: false,
                        message: "",
                        valid: "validating",
                        publicKey: ""
                }
        }

        handleSubmit = () => {
                const { currentPwd, newPwd, checkPwd } = this.state;
                if (!checkPwd) {
                        this.setState({ isChecked: true, message: "Please confirm your new Password!", valid: "error" });
                } else if (newPwd !== checkPwd) {
                        this.setState({ isChecked: true, message: "The passwords are inconsistent!", valid: "error" })
                } else {
                        this.getPublicKey();
                }

        }

        checkConfirmPwd= () => {
                const { currentPwd, newPwd, checkPwd } = this.state;
                if (!checkPwd) {
                        this.setState({ isChecked: true, message: "Please confirm your new Password!", valid: "error" });
                } else if (newPwd !== checkPwd) {
                        this.setState({ isChecked: true, message: "The passwords are inconsistent!", valid: "error" })
                } else {
                        this.getPublicKey();
                }

        }

        getPublicKey = () => {
                if (this.state.publicKey !== "") {
                        this.updatePwd();
                } else {
                        var _this = this;
                        post(api.getPublicKey).then(function (response) {
                                _this.setState({ publicKey: response }, () => {
                                        _this.updatePwd();
                                })
                        }).catch(function (error) {
                                notification['error']({
                                        message: error,
                                });
                        })
                }
        }

        updatePwd = () => {
                const { currentPwd, newPwd, checkPwd } = this.state;
                const { userId } = sessionManager.getUserInfo();
                this.setState({ valid: 'validating', loading: true })
                const submitData = { 
                        userId, 
                        "currentPwd": encrypt(currentPwd, this.state.publicKey), 
                        "newPwd": encrypt(newPwd, this.state.publicKey), 
                        "checkPwd": encrypt(checkPwd, this.state.publicKey), 
                        "merchantId": sessionManager.getMerchantId()
                }
                var _this = this;
                post(api.updatePwd, submitData).then(function (response) {
                         notification['success']({
                                 message: response + " Log back in three seconds later.",
                                 duration: 3
                         });
                        
                        _this.setState({ loading: false }, () => {
                                setTimeout(() => {
                                        sessionManager.signout(); 
                                        _this.props.history.push("/success")
                                }, 1000)
                        })

                }).catch(function (error) {
                        console.log("updatePwdError", error)
                        notification['error']({
                                message: error,
                        });
                        _this.setState({ loading: false })
                })
        }


        render() {
                return (<div style={{ marginTop: '80px' }}>
                        <Form
                                onFinish={this.handleSubmit}
                                name="basic"
                                labelCol={{ span: 4 }}
                                autoComplete="off"
                        >
                                <Spin spinning={this.state.loading}>
                                        <Form.Item
                                                name="Current Password"
                                                label="Current Password"
                                                rules={[{ required: true, message: 'Please input your current password!' }]}>
                                                <Input.Password onChange={event => this.setState({ currentPwd: event.target.value })} size="large" style={{ width: '500px' }} placeholder="current password" />
                                        </Form.Item>
                                        <Form.Item
                                                name="newPwd"
                                                label="New Password"
                                                rules={[{ required: true, message: 'Please input your new password!' }]}>
                                                <Input.Password onChange={event => this.setState({ newPwd: event.target.value })} size="large" style={{ width: '500px' }} placeholder="new password" />
                                        </Form.Item>
                                        <Form.Item
                                                // hasFeedback={this.state.isChecked}
                                                // validateStatus={this.state.valid}
                                                // help={this.state.message}
                                                name="Confirm New Password"
                                                label="Confirm New Password"
                                                rules={[{ required: true, message: 'Confirm New Password!' }, ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                          if (!value || getFieldValue('newPwd') === value) {
                                                            return Promise.resolve();
                                                          }
                                                          return Promise.reject('The passwords are inconsistent!!');
                                                        },
                                                      }),]}>
                                                <Input.Password onChange={event => this.setState({ checkPwd: event.target.value })} size="large" style={{ width: '500px' }} placeholder="confirm new password" />
                                        </Form.Item>
                                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                                                <Button size="large" type="primary" htmlType="submit" >
                                                        Submit
                                                </Button>
                                        </Form.Item>
                                </Spin>
                        </Form>
                </div>)
        }
}

export default Settings;